import { render, staticRenderFns } from "./ModalFormPK.vue?vue&type=template&id=083edcfe&scoped=true"
import script from "./ModalFormPK.vue?vue&type=script&lang=js"
export * from "./ModalFormPK.vue?vue&type=script&lang=js"
import style0 from "./ModalFormPK.vue?vue&type=style&index=0&id=083edcfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083edcfe",
  null
  
)

export default component.exports